import { API_URL } from "../../constants/url";

export const PUBLIC_API_URL = API_URL.replace(/\/admin\/?$/, "/user/public/");

export type PublicLegalContent = {
  title: string;
  html: string;
};

export type PublicContactContent = {
  email: string;
  phone: string;
  dialCode: string;
  whatsappPhone: string;
  whatsappDialCode: string;
  country: string;
};

export async function fetchPublicJson<T>(path: string): Promise<T | null> {
  const res = await fetch(`${PUBLIC_API_URL}${path}`);
  if (!res.ok) {
    throw new Error(`Request failed with ${res.status}`);
  }
  const json = await res.json();
  return (json?.data as T) ?? null;
}
